import { useEffect } from 'react';
var useCarouselEffects = function (_a) {
    var carouselEl = _a.carouselEl, index = _a.index, perMove = _a.perMove, length = _a.length, setCurrentSlide = _a.setCurrentSlide;
    useEffect(function () {
        if (!index) {
            carouselEl.current.splide.go(0);
        }
        else if (index > 0) {
            setCurrentSlide(index);
        }
    }, [index, perMove, length]);
    useEffect(function () {
        var _a;
        var slideRefs = (_a = carouselEl === null || carouselEl === void 0 ? void 0 : carouselEl.current) === null || _a === void 0 ? void 0 : _a.slides;
        slideRefs === null || slideRefs === void 0 ? void 0 : slideRefs.forEach(function (slide) {
            var focusableElements = slide.querySelectorAll('button, a');
            var isAriaHidden = slide.getAttribute('aria-hidden');
            if (isAriaHidden) {
                focusableElements.forEach(function (element) {
                    element.setAttribute('tabIndex', '-1');
                });
            }
            else {
                focusableElements.forEach(function (element) {
                    element.setAttribute('tabIndex', '0');
                });
            }
        });
    });
};
export default useCarouselEffects;
